(function initMrcoolAccordion() {
  const root = document.getElementById("mrcool-accordion");
  if (!root) return;

  const ONE_OPEN_AT_A_TIME = true;

  const items = Array.from(root.querySelectorAll(".mrcool-acc__item"));

  // Wrap panel contents in an inner div for padding (optional but helps animation)
  items.forEach((item) => {
    const btn = item.querySelector(".mrcool-acc__header");
    const panel = item.querySelector(".mrcool-acc__panel");
    if (!btn || !panel) return;

    // Add inner wrapper once
    if (!panel.querySelector(".mrcool-acc__panel-inner")) {
      const inner = document.createElement("div");
      inner.className = "mrcool-acc__panel-inner";
      while (panel.firstChild) inner.appendChild(panel.firstChild);
      panel.appendChild(inner);
    }

    // Ensure starting state is closed
    btn.setAttribute("aria-expanded", "false");
    panel.style.height = "0px";
  });

  function closeItem(item) {
    const btn = item.querySelector(".mrcool-acc__header");
    const panel = item.querySelector(".mrcool-acc__panel");
    if (!btn || !panel) return;

    btn.setAttribute("aria-expanded", "false");
    panel.style.height = panel.scrollHeight + "px"; // set current height first
    // next frame -> animate to 0
    requestAnimationFrame(() => {
      panel.style.height = "0px";
    });
  }

  function openItem(item) {
    const btn = item.querySelector(".mrcool-acc__header");
    const panel = item.querySelector(".mrcool-acc__panel");
    if (!btn || !panel) return;

    btn.setAttribute("aria-expanded", "true");
    panel.style.height = panel.scrollHeight + "px";

    // After transition, let it be "auto" height so content changes don't break
    const onEnd = (e) => {
      if (e.propertyName !== "height") return;
      panel.style.height = "auto";
      panel.removeEventListener("transitionend", onEnd);
    };
    panel.addEventListener("transitionend", onEnd);
  }

  function toggleItem(item) {
    const btn = item.querySelector(".mrcool-acc__header");
    const panel = item.querySelector(".mrcool-acc__panel");
    if (!btn || !panel) return;

    const isOpen = btn.getAttribute("aria-expanded") === "true";

    if (ONE_OPEN_AT_A_TIME && !isOpen) {
      items.forEach((other) => {
        if (other !== item) closeItem(other);
      });
    }

    if (isOpen) closeItem(item);
    else openItem(item);
  }

  root.addEventListener("click", (e) => {
    const btn = e.target.closest(".mrcool-acc__header");
    if (!btn || !root.contains(btn)) return;

    const item = btn.closest(".mrcool-acc__item");
    if (!item) return;

    // If panel height was "auto" from an open state, reset to px before closing
    const panel = item.querySelector(".mrcool-acc__panel");
    if (panel && panel.style.height === "auto") {
      panel.style.height = panel.scrollHeight + "px";
      // allow the browser to apply that height before we animate
      requestAnimationFrame(() => toggleItem(item));
      return;
    }

    toggleItem(item);
  });

  // Optional: keyboard convenience (Enter/Space already works on <button>)
  root.addEventListener("keydown", (e) => {
    if (e.key !== "Escape") return;
    // Escape closes all
    items.forEach(closeItem);
  });
})();
